import PropTypes from 'prop-types';
import React from 'react';

const SearchSkinny = ({ width, height }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Search</title>
    <path
      d="M10.4713 17.9427C14.5977 17.9427 17.9427 14.5977 17.9427 10.4713C17.9427 6.34503 14.5977 3 10.4713 3C6.34503 3 3 6.34503 3 10.4713C3 14.5977 6.34503 17.9427 10.4713 17.9427Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.0006 21L16.0273 16.0268"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

SearchSkinny.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SearchSkinny.defaultProps = {
  width: 24,
  height: 24,
};

export default SearchSkinny;
